var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.687 14.249L18.667 22H22L13.947 2H10.9l1.068 2.724H8.924L2 22h3.246l2.064-5.127h7.353l1.024-2.624zm-3.718-9.511l3.718 9.511H8.255l3.714-9.511z",
    fill: "#FF6063"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjY4NjYgMTQuMjQ5TDE4LjY2NzYgMjJIMjJMMTMuOTQ2NSAySDEwLjkwMTNMMTEuOTY5MyA0LjcyNDQySDguOTI0MTVMMiAyMkg1LjI0NTk1TDcuMzA5NTQgMTYuODcyNkgxNC42NjMxTDE1LjY4NjYgMTQuMjQ5Wk0xMS45NjkzIDQuNzM4MDRMMTUuNjg2NiAxNC4yNDlIOC4yNTQ4OEwxMS45NjkzIDQuNzM4MDRaIiBmaWxsPSIjRkY2MDYzIi8+Cjwvc3ZnPgo=";
export { SvgAIcon as ReactComponent };